// ============================================================
// src/lib/supabase.js
// ============================================================
// Replace these two values with your own from:
// https://supabase.com/dashboard → your project → Settings → API
// ============================================================

import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://bsxsdxzbhuhzrnbwlvbl.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJzeHNkeHpiaHVoenJuYndsdmJsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzk3Nzg1ODEsImV4cCI6MjA5NTM1NDU4MX0.RYWLVbBEzPsr9QP_yZ1ggW-HLK3G4o6rKEvCS1Q-1xQ'

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY)


// ============================================================
// SUPABASE SCHEMA - run this SQL in your Supabase SQL editor
// Dashboard → SQL Editor → New Query → paste → Run
// ============================================================

/*

-- Enable Row Level Security on all tables

CREATE TABLE profiles (
  id UUID PRIMARY KEY REFERENCES auth.users(id) ON DELETE CASCADE,
  full_name TEXT,
  currency TEXT DEFAULT 'GBP',
  monthly_income NUMERIC DEFAULT 0,
  created_at TIMESTAMPTZ DEFAULT NOW()
);

CREATE TABLE accounts (
  id UUID PRIMARY KEY DEFAULT gen_random_uuid(),
  user_id UUID REFERENCES auth.users(id) ON DELETE CASCADE,
  name TEXT NOT NULL,
  type TEXT NOT NULL, -- 'current', 'savings', 'isa', 'pension', 'investment'
  balance NUMERIC DEFAULT 0,
  created_at TIMESTAMPTZ DEFAULT NOW()
);

CREATE TABLE budgets (
  id UUID PRIMARY KEY DEFAULT gen_random_uuid(),
  user_id UUID REFERENCES auth.users(id) ON DELETE CASCADE,
  month TEXT NOT NULL, -- e.g. '2025-06'
  category TEXT NOT NULL,
  budgeted NUMERIC DEFAULT 0,
  spent NUMERIC DEFAULT 0,
  created_at TIMESTAMPTZ DEFAULT NOW(),
  UNIQUE(user_id, month, category)
);

CREATE TABLE debts (
  id UUID PRIMARY KEY DEFAULT gen_random_uuid(),
  user_id UUID REFERENCES auth.users(id) ON DELETE CASCADE,
  name TEXT NOT NULL,
  lender TEXT,
  original_balance NUMERIC DEFAULT 0,
  current_balance NUMERIC DEFAULT 0,
  apr NUMERIC DEFAULT 0,
  monthly_payment NUMERIC DEFAULT 0,
  priority TEXT DEFAULT 'medium', -- 'high', 'medium', 'low'
  created_at TIMESTAMPTZ DEFAULT NOW()
);

CREATE TABLE goals (
  id UUID PRIMARY KEY DEFAULT gen_random_uuid(),
  user_id UUID REFERENCES auth.users(id) ON DELETE CASCADE,
  name TEXT NOT NULL,
  target_amount NUMERIC DEFAULT 0,
  current_amount NUMERIC DEFAULT 0,
  monthly_contribution NUMERIC DEFAULT 0,
  target_date DATE,
  created_at TIMESTAMPTZ DEFAULT NOW()
);

CREATE TABLE net_worth_snapshots (
  id UUID PRIMARY KEY DEFAULT gen_random_uuid(),
  user_id UUID REFERENCES auth.users(id) ON DELETE CASCADE,
  month TEXT NOT NULL, -- e.g. '2025-06'
  total_assets NUMERIC DEFAULT 0,
  total_debts NUMERIC DEFAULT 0,
  net_worth NUMERIC DEFAULT 0,
  created_at TIMESTAMPTZ DEFAULT NOW(),
  UNIQUE(user_id, month)
);

-- Row Level Security policies

ALTER TABLE profiles ENABLE ROW LEVEL SECURITY;
ALTER TABLE accounts ENABLE ROW LEVEL SECURITY;
ALTER TABLE budgets ENABLE ROW LEVEL SECURITY;
ALTER TABLE debts ENABLE ROW LEVEL SECURITY;
ALTER TABLE goals ENABLE ROW LEVEL SECURITY;
ALTER TABLE net_worth_snapshots ENABLE ROW LEVEL SECURITY;

CREATE POLICY "Users can only access their own profile"
  ON profiles FOR ALL USING (auth.uid() = id);

CREATE POLICY "Users can only access their own accounts"
  ON accounts FOR ALL USING (auth.uid() = user_id);

CREATE POLICY "Users can only access their own budgets"
  ON budgets FOR ALL USING (auth.uid() = user_id);

CREATE POLICY "Users can only access their own debts"
  ON debts FOR ALL USING (auth.uid() = user_id);

CREATE POLICY "Users can only access their own goals"
  ON goals FOR ALL USING (auth.uid() = user_id);

CREATE POLICY "Users can only access their own snapshots"
  ON net_worth_snapshots FOR ALL USING (auth.uid() = user_id);

-- Auto-create profile when user signs up
CREATE OR REPLACE FUNCTION handle_new_user()
RETURNS TRIGGER AS $$
BEGIN
  INSERT INTO profiles (id, full_name)
  VALUES (NEW.id, NEW.raw_user_meta_data->>'full_name');
  RETURN NEW;
END;
$$ LANGUAGE plpgsql SECURITY DEFINER;

CREATE TRIGGER on_auth_user_created
  AFTER INSERT ON auth.users
  FOR EACH ROW EXECUTE FUNCTION handle_new_user();

*/


// ── Date utilities - always use local time, never UTC ──
export function getLocalMonth(date = new Date()) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`
}

export function localMonthLabel(monthStr) {
  // monthStr = '2026-05' - use day 15 to avoid any timezone edge cases
  const [year, month] = monthStr.split('-')
  const d = new Date(parseInt(year), parseInt(month) - 1, 15)
  return d.toLocaleString('en-GB', { month: 'long', year: 'numeric' })
}
